import React, { FC } from 'react';
import loadable from '@loadable/component';
import { OverlayId } from '../types';
import Flyout from '../GenericFlyout';

const PDPZoomFlyout: FC = () => {
    const ZoomContent = loadable(() => import('./ZoomContent'));
    return (
        <Flyout identifier={OverlayId.PDP_IMAGE_ZOOM} hasCustomHeader>
            <ZoomContent />
        </Flyout>
    );
};

export default PDPZoomFlyout;
